import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Customer } from '../webApi/DataModels'
import { map, filter } from 'lodash'
class CustomerState {
  customers:Customer[] = []
  customerOptions:any[] = []
}
const mutations = <MutationTree<CustomerState>>{
  setCustomers (state: CustomerState, countries: Customer[]) {
    state.customers = countries
    state.customerOptions = countries.map((customer: Customer) => {
      return {
        value: customer.Customer_ID,
        label: customer.Customer_Name,
        selected: false
      }
    })
    window.sessionStorage.setItem('Customer_List', JSON.stringify(state.customers))
  },
  reset (state:CustomerState) {
    state.customers = []
    state.customerOptions = []
  }
}
const actions = <ActionTree<CustomerState, any>>{
  reset (store: ActionContext<CustomerState, any>):void {
    store.commit('reset')
  },
  loadCustomers (store: ActionContext<CustomerState, any>):Promise<any> {
    if (window.sessionStorage.getItem('Customer_List') != null) {
      // the list has already been stored in session
      store.commit('setCustomers', JSON.parse(window.sessionStorage.getItem('Customer_List')))
      return Promise.resolve('success')
    } else {
      // the list has not been stored in session yet, load from server
      return webApi.customer.get_Customers().then(
        (response) => {
          // Store the response
          store.commit('setCustomers', response.data)
          return Promise.resolve('success')
        }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading customers: ' + response.data.ExceptionMessage)
        return Promise.reject(response)
      })
    }
  }
}
const getters = <GetterTree<CustomerState, any>> {
  customers: (state) => {
    return state.customers
  },
  customerOptions: (state) => {
    return state.customerOptions
  },
  customerNames (state:CustomerState):any {
    return (customerIDs:number[]) => {
      return map(filter(state.customers, customer => (customerIDs.indexOf(customer.Customer_ID) > -1)), 'Customer_Name')
    }
  }
}
export default ({
  namespaced: true,
  state: new CustomerState(),
  mutations,
  actions,
  getters
})
